<template>
  <div class="main-wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="custom-catering">
      <el-tab-pane label="今日餐況" name="first">
        <div class="container" v-if="activeName == 'first'">
            <today v-if="isshow" @done="setShow"></today>
            <list v-else :type="type"></list>
        </div>
      </el-tab-pane>
      <el-tab-pane label="明日選餐" name="second">
        <div class="container" v-if="activeName == 'second'">
            <tomorrow v-if="isshow" @done="setShow"></tomorrow>
            <list v-else :type="type"></list>
        </div>
      </el-tab-pane>
      <el-tab-pane label="餐況查詢" name="third">
        <div class="container" v-if="activeName == 'third'">
          <seacher></seacher>
          <list></list>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>


import { printDate } from "@/utils";

export default {
  name: "Meal",
  components:{
     today: () => import('@/views/Meal/today.vue'),
     list: () => import('@/views/Meal/list.vue'),
    tomorrow: () => import('@/views/Meal/tomorrow.vue'),
    seacher: () => import('@/views/Meal/seacher.vue')
  },
  data() {
    return {
      activeName: "first",
      time:'',
      isshow:true,
      type: ''
    };
  },
  created() {
     this.time = printDate()
    this.$store.commit('dataTime/SET_Time', this.time)
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    setShow( type ){
        this.type = type
        this.isshow = false
    },
    handleClick() {
      this.isshow = true
      if(this.activeName == 'second') {
         const today = new Date();
         this.time = new Date(today);
         this.time.setDate(today.getDate() + 1);
         this.time = printDate(this.time)
         this.$store.commit('dataTime/SET_Time', this.time)
       }else{
         this.time = printDate()
         this.$store.commit('dataTime/SET_Time', this.time)
       }
    }
  }
};
</script>

<style lang="scss" scoped>
.home {

}
</style>
